import { Component } from "@angular/core";

@Component({
  selector: "oe-flat-widget-details-button",
  templateUrl: "./flat-widget-details-button.html",
  styleUrls: ["./flat-widget-details-button.css"],
})
export class FlatWidgetDetailsButtonComponent {}
